import { type ColorType } from '@pollux-docaposte/core-design-system'
import { Component, Prop, h, Host, Element } from '@stencil/core'

@Component({
  tag: 'cobalt-tooltip',
  styleUrl: 'cobalt-tooltip.css'
})
export class CobaltTooltip {
  /**
   * Tooltip alignment prop to where the tooltip will appear
   */
  @Prop({ reflect: true }) direction?: 'top' | 'right' | 'bottom' | 'left' = 'top'
  /**
   * Change the `background-color` of the tooltip content.
   */
  @Prop({ mutable: true }) tooltipBackgroundColor?: ColorType = 'color-neutral-background-strong'
  /**
   * Change the `color` of the tooltip content.
   */
  @Prop({ mutable: true }) tooltipColor?: ColorType = 'color-neutral-content-medium'
  /**
   * Change the `padding` of the tooltip content.
   */
  @Prop({ mutable: true }) tooltipPadding?: string = 'var(--number-spacing-4xsmall) var(--number-spacing-3xsmall)'
  @Element() element: HTMLElement

  render(): void {
    return (
      <Host class="typography-body-small-regular">
        <core-tooltip direction={this.direction} tooltipBackgroundColor={this.tooltipBackgroundColor} tooltipColor={this.tooltipColor} tooltipPadding={this.tooltipPadding}>
          <slot slot="trigger-element" name="trigger-element"></slot>
          <slot slot="tooltip-content" name="tooltip-content"></slot>
        </core-tooltip>
      </Host>
    )
  }
}
